'use strict';

function LoanOfferReupTray() {
  this.extends = [_Paths];
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this.init = function () {
    if ($('#tray-navigation').mogo().create) {
      this._initializeMenu();
    }
  };

  this.initAllReady = function () {};

  this._initializeMenu = function () {
    if (window.location.pathname === this.paths.loans.offer_refresh_review_info) {
      this.trayNavItems = [{
        title: 'Review information',
        url: this.paths.loans.offer_refresh_review_info,
        disabled: false,
        completed: false
      }, {
        title: 'Select amount',
        url: this.paths.loans.offer_refresh_select_amount,
        disabled: true,
        completed: false
      }];
    } else {
      this.trayNavItems = [{
        title: 'Additional information',
        url: this.paths.loans.offer_refresh_additional_info,
        disabled: false,
        completed: false
      }, {
        title: 'Select amount',
        url: this.paths.loans.offer_refresh_select_amount,
        disabled: true,
        completed: false
      }];
    }

    $('#tray-navigation').mogo().create('TrayNavigation', {
      steps: {
        items: this.trayNavItems,
        sequential: true,
        selectedIndex: 0
      },
      progressIndicator: 'percent'
    });

    this.presenter.scanDOM(this.node);
  };

  this.destroy = function () {};
}